import {get} from "lodash"
import BaseService from "./Base"
import {IdPalSubmissionListRequest, IdPalSubmissionListResponse} from "types/integrations/idPalSubmission"

class IdPalSubmissionsService extends BaseService {
    async list(params: IdPalSubmissionListRequest): Promise<IdPalSubmissionListResponse> {
        const response = await this.post("/v1/integrations/id-pal-submissions/list", params)
        return get(response, "data", {success: false, data: [], total: 0})
    }
}

export default IdPalSubmissionsService
